var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg59(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4741 2.55656V10.751C17.9325 10.4723 17.3251 10.301 16.6759 10.2612V4.35477C16.6759 3.85892 16.2737 3.45666 15.7778 3.45666H3.19632C2.70047 3.45666 2.29822 3.85892 2.29822 4.35477V13.4434H12.0599C11.9325 13.8636 11.8628 14.3077 11.8628 14.7677C11.8628 14.925 11.8707 15.0823 11.8887 15.2396H1.4001C0.904255 15.2396 0.5 14.8373 0.5 14.3415V2.55656C0.5 2.06071 0.904255 1.65845 1.4001 1.65845H17.574C18.0699 1.65845 18.4741 2.06071 18.4741 2.55656Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99407 5.25293H13.9801C14.4764 5.25293 14.8787 5.65525 14.8787 6.15154C14.8787 6.64782 14.4764 7.05014 13.9801 7.05014H4.99407C4.49778 7.05014 4.09546 6.64782 4.09546 6.15154C4.09546 5.65525 4.49778 5.25293 4.99407 5.25293Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79118 8.84729H12.1828C12.6791 8.84729 13.0814 9.24961 13.0814 9.7459C13.0814 10.2422 12.6791 10.6445 12.1828 10.6445H6.79118C6.2949 10.6445 5.89258 10.2422 5.89258 9.7459C5.89258 9.24961 6.2949 8.84729 6.79118 8.84729Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3786 11.6453C14.6759 11.6453 13.2571 13.0641 13.2571 14.7667C13.2571 15.9964 14.0138 17.1315 15.0543 17.6045V19.6854L16.3786 18.8341L17.7028 19.78V17.6045C18.7433 17.1315 19.5 15.9964 19.5 14.7667C19.5 13.0641 18.1758 11.6453 16.3786 11.6453ZM16.3786 16.091C15.6218 16.091 15.0543 15.5235 15.0543 14.7667C15.0543 14.01 15.6218 13.4425 16.3786 13.4425C17.1353 13.4425 17.7028 14.01 17.7028 14.7667C17.7028 15.5235 17.1353 16.091 16.3786 16.091Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg59);
export default __webpack_public_path__ + "static/media/svg59.97ebcdab9452361c6c4d55e4c1f51cfb.svg";
export { ForwardRef as ReactComponent };